<template src='./index.html'></template>
<script>
import data from './data.js';

export default {
    name: 'zzq_czzzq',
    props: {
        zzqdialog: {
            type: Boolean,
            default: false
        },
        //用于判断是哪个界面  0:新增 1：编辑
        wikiType: {
            type: String,
            default: ''
        },
        formData: {
            type: Object,
            default: {}
        },
        title: {
            type: String,
            default: ''
        }
    },
    watch: {
        formData: function(indexVal, oldVal) {

        },
        title: function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(() => {
                    this.dialogTitle = this.title;
                })
            }
        }
    },
    data: function() {
        return {
            formlist: data.formlist,
            pagination: data.pagination,
            tablekey: 0,
            overlength: 0,
            formdata: data.formdata,
            dialogTitle: ""
        };
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            // 初始化
        },
        getdata(e) {
        },
        fetchResultShow() {
            // 数据查询
        },
        sizechange(e) {
            this.pagination.pageSize = e;
            this.fetchResultShow();
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.fetchResultShow();
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.fetchResultShow();
        },
        closediag() {
            this.$emit('closediag', false);
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
